"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spin = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@bem-react/core");
var Spin_1 = require("./Spin");
// _position
var Spin_position_center_1 = require("./_position/Spin_position_center");
//  _size
var Spin_size_l_1 = require("./_size/Spin_size_l");
var Spin_size_m_1 = require("./_size/Spin_size_m");
var Spin_size_s_1 = require("./_size/Spin_size_s");
var Spin_size_xs_1 = require("./_size/Spin_size_xs");
var Spin_size_xxs_1 = require("./_size/Spin_size_xxs");
// _view
var Spin_view_default_1 = require("./_view/Spin_view_default");
tslib_1.__exportStar(require("./Spin"), exports);
exports.Spin = core_1.compose(core_1.composeU(Spin_size_l_1.withSizeL, Spin_size_m_1.withSizeM, Spin_size_s_1.withSizeS, Spin_size_xs_1.withSizeXS, Spin_size_xxs_1.withSizeXXS), Spin_position_center_1.withPositionCenter, Spin_view_default_1.withViewDefault)(Spin_1.Spin);
